(ns bleene.app.events
  (:require
   [re-frame.core :as re-frame]
   [bleene.mock-data]
   [bleene.mock-transforms]))


(re-frame/reg-event-db
 :app/initialize
 (fn [db _]
   (let [initialized? (:dag/initilized? db)]
     (cond-> db
       (not initialized?)
       (merge db
              {:dag/initilized? true

               :active-pane  :main-pane

               :page         {:panes [:sidebar :main-pane]}

               :panes        {:main-pane {:id         :main-pane
                                          :visible?   true
                                          :type       :editor-pane
                                          :active-tab :default-dag
                                          :tabs       [:default-dag]}}

               :tabs         {:default-dag {:id   :default-dag
                                            :name "Pipelines"
                                            :type :dag}}

               :dag-params   {:scale-by               1.08
                              :min-scale              0.05
                              :max-scale              1.5
                              :node-text-width        120
                              :node-width             400
                              :node-height            130
                              :target-circle-offset-x 10}

               :dag          {:default-dag {:scale           0.5
                                            :offset-x        0
                                            :offset-y        0
                                            :x               0
                                            :y               0
                                            :navigate-to     nil
                                            :filters         nil
                                            :connected-nodes #{}
                                            :connected-edges #{}
                                            :nodes           []
                                            :edges           []
                                            :groups          ["root"]
                                            :selected-node   nil
                                            :selected-edge   nil
                                            :selected-group  nil
                                            :temp-connection nil
                                            :drawing-edge?   false
                                            :listen-events?  true}}

               :loader       {:loading? false}

               :context-menu {:open? false}

               :node-tooltip {:open?   false
                              :content nil}

               :dialog       {:open?   false
                              :context nil}

               :jobs         {}

               :connections  {}

               :groups       {"root" {:name  "root"
                                      :id    "root"
                                      :nodes []}}})))))


(re-frame/reg-event-db
 :app/add-mock-data
 (fn [db]
   (let [nodes          (get bleene.mock-data/response "nodes")
         edges          (get bleene.mock-data/response "edges")

         transforms     (get-in bleene.mock-transforms/transforms ["transforms" "data"])
         parent-groups  (get-in bleene.mock-transforms/transforms ["parent-groups"])

         group-names    (reduce (fn [acc group]
                                  (assoc acc (get group "id") (get group "name")))
                                {}
                                parent-groups)

         jobs           (reduce (fn [acc id]
                                  (let [transform (first (filter (fn [ts]
                                                                   (= id (get ts "id")))
                                                                 transforms))]

                                    (assoc acc id {:id        id
                                                   :name      (get transform "name")
                                                   :x         0
                                                   :y         0
                                                   :transform transform
                                                   :type      "transform"
                                                   :group-id  (or (get transform "group-id")
                                                                  "123123")
                                                   :status    (rand-nth [:success :pending :error :warning :default])})))
                                {}
                                nodes)


         grouped-jobs   (group-by :group-id (vals jobs))
         groups         (into {}
                              (map (fn [[group-id transforms]]
                                     [group-id {:name  (get group-names group-id)
                                                :id    group-id
                                                :nodes (mapv :id transforms)}])
                                   grouped-jobs))


         connections    (reduce (fn [acc [start-id end-id]]
                                  (let [id (str start-id ":" end-id)]
                                    (assoc acc id {:start    {:x 0 :y 0}
                                                   :end      {:x 0 :y 0}
                                                   :start-id start-id
                                                   :end-id   end-id
                                                   :type     :default
                                                   :id       id})))
                                {}
                                edges)

         jobs'          (reduce (fn [acc [_ {:keys [id start-id end-id]}]]
                                  (cond-> acc
                                          (some? start-id)
                                          (update-in [start-id :output] conj id)

                                          (some? end-id)
                                          (update-in [end-id :input] conj id)))
                                jobs
                                connections)

         job-ids        (keys jobs)
         connection-ids (keys connections)]

     (-> db
         (update-in [:dag :default-dag :groups] concat (keys groups))
         (update-in [:dag :default-dag :nodes] concat job-ids)
         (update-in [:dag :default-dag :edges] concat connection-ids)
         (update :groups merge groups)
         (update :jobs merge jobs')
         (update :connections merge connections)))))
